import { render, staticRenderFns } from "./Landbot.vue?vue&type=template&id=e460ab42"
import script from "./Landbot.vue?vue&type=script&lang=ts"
export * from "./Landbot.vue?vue&type=script&lang=ts"
import style0 from "./Landbot.vue?vue&type=style&index=0&id=e460ab42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports